export default __webpack_public_path__ + "static/media/junglecat-white.3a86473b.svg";